import { NamespacedImageKeys } from '@bonanza-social/moonlight';
import { RegistrationVariantEnum } from '../../utils/fetchRegistrationVariant';
import { RegistrationData } from '../registrationForm/registrationForm.types';
import { RegistrationConfigBase } from '../shared/registrationShared.types';
import { FieldConfig } from './registrationConfig.types';

export const RegistrationConfigThreeSteps: RegistrationConfigBase = {
  id: RegistrationVariantEnum.threeStep,
  countdownTimer: 900,
  hideProgressBar: true,
  steps: [
    {
      id: 'intro',
      disableHeader: true,
    },
    {
      id: 'offer',
      disableHeader: true,
      fields: ['promoId'] as (keyof RegistrationData)[],
      cta: 'ctaOffer',
    },
    {
      id: 'join',
      stepTitleNS: 'registration',
      stepTitleKey: 'joinStepTitle',
      stepDescriptionNS: 'registration',
      stepDescriptionKey: 'joinStepDescription',
      fields: ['email', 'password'] as (keyof RegistrationData)[],
      cta: 'continueButton',
    },
    {
      id: 'verify',
      stepTitleNS: 'registration',
      stepTitleKey: 'verifyStepTitle',
      stepDescriptionNS: 'registration',
      stepDescriptionKey: 'verifyStepDescription',
      fields: [
        'firstName',
        'middleName',
        'lastName',
        'birthDate',
        'phone',
        'address',
      ] as (keyof RegistrationData)[],
      cta: 'continueButton',
      featureTip: {
        descriptionKey: 'phoneFeatureTip',
        image: 'common.BonanzaWheel',
      },
    },
    {
      id: 'complete',
      stepTitleNS: 'registration',
      stepTitleKey: 'termsPageLabel',
      stepDescriptionNS: 'registration',
      stepDescriptionKey: 'termsPageDescription',
      fields: ['marketing', 'age', 'terms'] as (keyof RegistrationData)[],
      cta: 'ctaComplete',
      featureTip: {
        descriptionKey: 'addressFeatureTip',
        image: 'common.BonanzaPiggy',
      },
    },
  ],
  fields: {
    promoId: {
      hideGenericError: true,
    },
    email: {
      placeholderNS: 'registration',
      placeholderKey: 'emailLabel',
      footerNS: 'registration',
      footerKey: 'emailFooter',
      type: 'text',
      inputMode: 'email',
      autoComplete: 'email',
      keyboardType: 'email-address',
      textContentType: 'emailAddress',
      autoCapitalize: 'none',
    },
    password: {
      secureTextEntry: true,
      placeholderNS: 'registration',
      placeholderKey: 'passwordLabel',
      footerNS: 'registration',
      footerKey: 'passwordFooter',
      type: 'password',
      autoComplete: 'password',
      textContentType: 'password',
    },
    phone: {
      headerNS: 'registration',
      headerKey: 'phoneNumber',
      footerNS: 'registration',
      footerKey: 'phoneFooter',
      autoComplete: 'tel-national',
      textContentType: 'telephoneNumber',
      type: 'text',
      inputMode: 'tel',
    },
    firstName: {
      headerKey: 'legalName',
      placeholderNS: 'registration',
      placeholderKey: 'firstNameOnID',
      autoComplete: 'given-name',
      textContentType: 'givenName',
    },
    middleName: {
      placeholderNS: 'registration',
      placeholderKey: 'middleNameLabel',
      autoComplete: 'additional-name',
      textContentType: 'middleName',
    },
    lastName: {
      placeholderNS: 'registration',
      placeholderKey: 'lastNameOnID',
      autoComplete: 'family-name',
      textContentType: 'familyName',
    },
    gender: {
      headerNS: 'registration',
      headerKey: 'genderTitleLabel',
      placeholderNS: 'registration',
      placeholderKey: 'genderLabel',
    },
    industry: {
      headerNS: 'registration',
      headerKey: 'industryTitleLabel',
      placeholderNS: 'registration',
      placeholderKey: 'industryDescriptionLabel',
    },
    occupation: {
      headerNS: 'registration',
      headerKey: 'occupationLabel',
      placeholderNS: 'registration',
      placeholderKey: 'occupationPlaceholder',
    },
    limits: {
      placeholderNS: 'registration',
      placeholderKey: 'limitsPlaceholderLabel',
    },
    marketing: {
      placeholderNS: 'registration',
      placeholderKey: 'marketingLabel',
    },
    age: {
      placeholderNS: 'registration',
      placeholderKey: 'ageLabel',
    },
    terms: {
      placeholderNS: 'registration',
      placeholderKey: 'termsLabel',
    },
    pep: {
      placeholderNS: 'registration',
      placeholderKey: 'pepLabel',
    },
    fit: {
      placeholderNS: 'registration',
      placeholderKey: 'fitLabel',
    },
  } as Record<keyof RegistrationData, FieldConfig>,
};
